document.addEventListener("DOMContentLoaded", function () {
  // Código usando antes para controla mudança de preço das variações
  // const variaveis = document.querySelectorAll("input[data-option-position]");
  // if (variaveis.length === 0) {
  //   return;
  // }

  // variaveis.forEach((element) => {
  //   element.classList.add("not_user_select");
  //   element.addEventListener("click", mudancaDeVariavel);
  // });

  const fotosParaDeletar = document.querySelectorAll("span.deleta_foto");
  if (fotosParaDeletar.length === 0) {
    return;
  }

  fotosParaDeletar.forEach((element) => {
    id = element.id;
    position = element.innerText;

    foto = document.querySelector(`div[data-media-id="${id}"]`);
    if (foto === null) {
      return;
    }

    if (position.trim() !== "1") {
      foto.parentNode.removeChild(foto);
    } else {
      foto.setAttribute("data-media-id", `${id}p`);
    }

    element.parentNode.removeChild(element);
  });
});

// const mudancaDeVariavel = (e) => {
//   const atributoAtivo = "variante_ativa";
//   const atributoOculto = "variante_oculta";

//   const varianteAtiva = document.querySelector(`.${atributoAtivo}`);
//   if (varianteAtiva !== null) {
//     varianteAtiva.classList.remove(atributoAtivo);
//     varianteAtiva.classList.add(atributoOculto);
//   }

//   const selecionado = e.target.innerText;
//   const variante = document.querySelector(
//     `[data-option-position="${selecionado}"]`.trim()
//   );

//   variante.classList.remove(atributoOculto);
//   variante.classList.add(atributoAtivo);
// };
